

<div class="container-fluid">
  <div class="row">
    <div class="col-9 scout-pt-title-cell" [ngStyle]="{'background-color': pt.color}">
      {{ pt.name }}
    </div>
    <div class="col-3 scout-pt-type-cell">
      {{ pt.type }}
    </div>
  </div>
</div>
 
<table class="table table-striped table-condensed table-sm scout-point-props-table">
  <tr><th>Latitude</th><td>{{strLat}}</td></tr>
  <tr><th>Longitude</th><td>{{strLng}}</td></tr>
  <tr *ngIf="pt.pointId">
    <th>Details</th>
    <td>
      <a href="javascript:false;" (click)="onShowPoint(pt.pointId)">
        Point {{pt.pointId}}
      </a>
      <a href="javascript:false;" 
          *ngIf="pt.pointData.fromPointId"
          (click)="onShowPoint(pt.pointData.fromPointId)">
        From {{pt.pointData.fromPointId}}
      </a>
    </td>
  </tr>
  <tr *ngIf="testPoint"><th>Test Order</th><td>#{{testPoint.order}} of {{testPointCnt}}</td></tr>
  <tr><th>External</th>
    <td>
      <a href="javascript:false;" (click)="onShowGoogleMapsPoint(strLat,strLng)">Google Maps</a>
    </td>
  </tr>
</table>

<table class="table table-striped table-condensed table-sm scout-point-props-table"
    *ngIf="testPoint">
  <tr>
    <th>Status</th>
    <td>
      <div class="d-flex flex-row">
        <div class="status-label p-2 mr-2" style="border-radius:4px;" [ngClass]="testPoint.statusId|taskStatusBorderedCss">
          {{testPoint.statusId|taskStatusName|titlecase}}
        </div>
      </div>
    </td>    
  </tr>
  <ng-container *ngIf="seq?.startTime">
    <tr>
      <th>Start</th>
      <td>{{seq.startTime|date:'yyyy-MM-dd HH:mm:ss'}}</td>
    </tr>
    <tr>
      <th>Stop</th>
      <td>{{seq.stopTime|date:'yyyy-MM-dd HH:mm:ss'}}</td>
    </tr>
    <tr>
      <th>Placed/Completed</th>
      <td>
        <ng-container *ngIf="!seq?.dialerSeqId; else haveDialerSeqId">
          {{seq.data?.callsPlaced}}/{{seq.data?.callsCompleted}}
        </ng-container>
        <ng-template #haveDialerSeqId>
          <a href="javascript:false;" (click)="onShowTestResults()">
            {{seq.data?.callsPlaced}}/{{seq.data?.callsCompleted}}
          </a>
        </ng-template>
      </td>
    </tr>
    <tr>
      <th>Tester</th>
      <td>{{userName$|async}}</td>
    </tr>
  </ng-container>
</table>

<div class="footer pt-sm-1">
  <button *ngIf="setSelectedPointFn && bShowSelectButton" class="btn btn-secondary btn-sm" (click)="changeGuard(selectedPt, onSelectPoint)">Select</button>
  <button *ngIf="showRefDataFn&&pt.type!='VIA'" class="btn btn-secondary btn-sm" (click)="onShowRefData()">Scout Ref</button>
</div>

<!-- TODO make a reusable modal with dialer results 
<ng-template #dialerResultsTmpl>
  <div style="width: 600px;overflow-y:auto;">
    <app-dialer-client-testseq [dialerSeqId]="seq.dialerSeqId">
    </app-dialer-client-testseq>
  </div>
  <button class="small btn btn-secondary" (click)="testResultsModalRef?.hide()"></button>
</ng-template>
-->